import React from 'react';

function Login() {
  return (
    <div>
      <h2>Login Page</h2>
      <p>Please enter your login details.</p>
      {/* You can add a form here */}
    </div>
  );
}

export default Login;
